import React from 'react';
import css from './single-class.scss';
import ConnectedLiveMathsLevelPicker from '../../../components/live-maths-level-picker/live-maths-level-picker';
import { getTranslationKey } from '../../../helpers/locale-helpers';
import { LEVEL } from '../../../components/report-filters/filter-constants';

const GROUP_NAME = 'name';
const COURSE_NAME = 'courseName';
const Q_PER_MIN = 'questionsPerMinute';
const TOTAL_CORRECT = 'totalCorrect';
const ACCURACY = 'accuracy';
const TOP_SCORE = 'topScore';
const STUDENT_NAME = 'studentName';

const generateColHeader = (mainText, subText) => {
    const i18n = window.i18n;
    return (
        <div className={css['col-header']}>
            <span>{i18n._(mainText)}</span>
            {subText && <span>({i18n._(subText)})</span>}
        </div>
    );
};

const SINGLE_CLASS_TABLE_CONFIG = {
    colGroups: [
        [
            {
                name: '', // this is set to class name in SingleClass component
                colIds: [GROUP_NAME],
                classes: css['class-name'],
                truncate: true,
                headerTruncate: true
            },
            {
                name: Q_PER_MIN,
                headerTransform: () =>
                    generateColHeader('Q/MIN', 'Column Header - Avg'),
                colIds: []
            },
            {
                name: TOTAL_CORRECT,
                headerTransform: () =>
                    generateColHeader(
                        'Column Header - Correct',
                        'Column Header - Total'
                    ),
                colIds: []
            },
            {
                name: ACCURACY,
                headerTransform: () =>
                    generateColHeader(
                        'Column Header - Accuracy',
                        'Column Header - Avg'
                    ),
                colIds: []
            },
            {
                name: TOP_SCORE,
                headerTransform: () =>
                    generateColHeader(
                        'Column Header - TopScore',
                        'Column Header - Lifetime'
                    ),
                colIds: []
            }
        ]
    ],
    cols: [
        {
            id: GROUP_NAME,
            name: getTranslationKey(LEVEL),
            doTranslation: true,
            classes: css['group-name'],
            truncate: true,
            onClick: null // this is set to load group view in the SingleClass component
        },
        {
            id: COURSE_NAME,
            headerTransform: () => <ConnectedLiveMathsLevelPicker />,
            headerColSpan: 4,
            colSpan: 4,
            classes: css['course-name']
        }
    ],
    nestedData: {
        id: 'studentLiveMathsResults',
        cols: [
            {
                id: STUDENT_NAME,
                truncate: true,
                classes: css['student-name'],
                onClick: null // this is set to load student view in the SingleClass component
            },
            { id: Q_PER_MIN },
            { id: TOTAL_CORRECT },
            { id: ACCURACY },
            { id: TOP_SCORE }
        ],
        emptyDataMessage: 'No Live Maths results found for this level'
    },
    emptyDataMessage: 'No Live Maths results found'
};

export { SINGLE_CLASS_TABLE_CONFIG, GROUP_NAME, STUDENT_NAME };



// WEBPACK FOOTER //
// ./containers/live-maths/single-class/single-class-constants.js